export default "__VITE_ASSET__HzOAR$SX__"